import * as React from 'react';

import { markerColors } from '@fhs/maps/src/components/markers/marker-colors';
import {
  PIN_ART_HEIGHT,
  PIN_ART_WIDTH,
  PIN_BADGE_PATH,
  PIN_MONOGRAM_PATH,
  PIN_REGISTERED_MARK_PATH,
  PIN_TEARDROP_PATH,
} from '@fhs/maps/src/components/markers/store-pin-paths';
import { Svg, SvgPath, SvgProps } from '@fhs-legacy/universal-components';

const StoreMarkerActive = (props: Omit<SvgProps, 'children'>) => (
  <Svg
    width={PIN_ART_WIDTH}
    height={PIN_ART_HEIGHT}
    fill="none"
    viewBox={`0 0 ${PIN_ART_WIDTH} ${PIN_ART_HEIGHT}`}
    {...props}
  >
    <SvgPath d={PIN_TEARDROP_PATH} fill={markerColors.selectedClosed} />
    <SvgPath d={PIN_REGISTERED_MARK_PATH} fill={markerColors.surface} />
    <SvgPath d={PIN_MONOGRAM_PATH} fill={markerColors.surface} fillRule="evenodd" />
    <SvgPath d={PIN_BADGE_PATH} fill={markerColors.surface} fillRule="evenodd" />
  </Svg>
);

export const storeActiveMarkerSvg = `
<svg width="${PIN_ART_WIDTH}" height="${PIN_ART_HEIGHT}" fill="none" viewBox="0 0 ${PIN_ART_WIDTH} ${PIN_ART_HEIGHT}" xmlns="http://www.w3.org/2000/svg">
  <path d="${PIN_TEARDROP_PATH}" fill="${markerColors.selectedClosed}" />
  <path d="${PIN_REGISTERED_MARK_PATH}" fill="${markerColors.surface}" />
  <path d="${PIN_MONOGRAM_PATH}" fill="${markerColors.surface}" fill-rule="evenodd" />
  <path d="${PIN_BADGE_PATH}" fill="${markerColors.surface}" fill-rule="evenodd" />
</svg>
`;

export default StoreMarkerActive;
